import {getFutureDay} from "@helpers/date";
import {DATE_FORMAT_POINT_SINGLE_VOYAGE} from "@containers/singleVoyage/containers/points/constants/dateFormat";
import moment from 'moment'

export const getRouteDefaultPlanedStartMutateSingleVoyage = (): string => {
    return moment(getFutureDay(1, DATE_FORMAT_POINT_SINGLE_VOYAGE), DATE_FORMAT_POINT_SINGLE_VOYAGE).toISOString()
}


export const getRouteDefaultPlanedEndMutateSingleVoyage = (): string => {
    return moment(getFutureDay(1, DATE_FORMAT_POINT_SINGLE_VOYAGE), DATE_FORMAT_POINT_SINGLE_VOYAGE).toISOString()
}
